import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WebhookDeliveriesGridStateType, GetWebhookDeliveriesGridCallPayloadType } from 'src/types/webhookDeliveriesGrid';

const initialState: WebhookDeliveriesGridStateType = {
    data: null,
    mode: 'grouped',
    loading: false,
    error: false,
};

export const webhookDeliveriesGridSlice = createSlice({
    name: 'webhookDeliveriesGrid',
    initialState,
    reducers: {
        getWebhookDeliveriesGridFetch: (
            state,
            action: PayloadAction<GetWebhookDeliveriesGridCallPayloadType | undefined>
        ) => {
            state.loading = true;
            state.error = false;
            if (action.payload?.mode) {
                state.mode = action.payload.mode;
            }
        },
        getWebhookDeliveriesGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getWebhookDeliveriesGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        retryWebhookDeliveryFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        retryWebhookDeliveryFetchSuccess: (state, action) => {
            state.loading = false;
        },
        retryWebhookDeliveryFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getWebhookDeliveriesGridFetch,
    getWebhookDeliveriesGridFetchSuccess,
    getWebhookDeliveriesGridFetchFailure,
    retryWebhookDeliveryFetch,
    retryWebhookDeliveryFetchSuccess,
    retryWebhookDeliveryFetchFailure,
} = webhookDeliveriesGridSlice.actions;

export default webhookDeliveriesGridSlice.reducer;
